import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";

const Heading = styled.section`
  ${tw`flex flex-row items-center my-[30px]`}
`;
const Content = styled.div`
  ${tw`flex-1`}
`;

const SectionHeading = (props) => (
  <Heading {...props}>
    <Content>
      {props.size == "large" ? (
        <h2>{props.children}</h2>
      ) : (
        <h5>{props.children}</h5>
      )}
    </Content>
  </Heading>
);

SectionHeading.propTypes = {
  children: PropTypes.any,
  size: PropTypes.string
};

export default SectionHeading;
